export default "__VITE_ASSET__BvtEEXg___"